<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Email template') }}</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
            <input-keyword
              @input="setKeywords"
              :placeholder="$t('Search')"
              class="mr-2" />
            <button
              type="button"
              class="btn btn-primary"
              @click="showCreateModal()">
              + {{ $t('New template') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">
      
      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="loadData">
        
        <template slot="content">
          <table class="table">
            <thead>
              <tr>
                <th-sort
                  field="name"
                  :value="sort"
                  @input="setSort">{{ $t('Name') }}</th-sort>
                <th-sort
                  field="created_at"
                  :value="sort"
                  @input="setSort">{{ $t('Created at') }}</th-sort>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="(item, index) in templatemails"
                :key="index">
                <td class="text-truncate"><a href="javascript:void(0)" @click="showEditModal(item)">{{ item.name }}</a></td>
                <td class="text-truncate">{{ $d(new Date(item.created_at), 'short') }}</td>
              </tr>
            </tbody>
          </table>
        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>

      <templatemail-form 
        v-if="modal_select"
        :initTemplatemail="modal_select" 
        @hideModal="hideModal ()" 
        @deleted="loadData(); hideModal()" 
        @saved="loadData(); hideModal()">
        </templatemail-form>

    </div>

  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import ThSort from '@/components/Parts/ThSort'
import TemplatemailForm from './TemplatemailForm'
import Paginaty from '@/components/Paginaty/Paginaty'

export default {
  name: 'Templatemail',
  components: {
    ThSort,
    TemplatemailForm,
    InputKeyword,
    Paginaty
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false,
      filters: {},
      sort: 'name'
    }
  },
  computed: {
    templatemails () {
      return this.$store.getters.getTemplatemails
    },
    paginate () {
      return this.$store.getters.getTemplatemailsPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    filters
    */
    setKeywords (keywords) {
      this.filters = keywords ? {name: '~' + keywords} : {}
      this.loadData(1)
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    },
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectTemplatemails', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Templatemail/Templatemail.vue